import * as React from "react";
import { forwardRef } from "react";
const SvgPreviousIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 6, height: 10, viewBox: "0 0 6 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M4.80078 8.79981L0.800781 4.79981L4.80078 0.799805", stroke: "#0950C3", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgPreviousIcon);
export default ForwardRef;
